/*
########   ##     ##  ##    ##    ######    ########   ####   #######   ##    ##   
##         ##     ##  ###   ##   ##    ##      ##       ##   ##     ##  ###   ##   
##         ##     ##  ####  ##   ##            ##       ##   ##     ##  ####  ##   
######     ##     ##  ## ## ##   ##            ##       ##   ##     ##  ## ## ##   
##         ##     ##  ##  ####   ##            ##       ##   ##     ##  ##  ####   
##         ##     ##  ##   ###   ##    ##      ##       ##   ##     ##  ##   ###   
##          #######   ##    ##    ######       ##      ####   #######   ##    ##   
*/

/**
 * Fonction qui analyse un json
 */
var jsonHandler = function(json) {
	if(json.redirect) {
		window.location = json.redirect;
	}
	if(json.message) {
		$('.retour').html(json.message);
	}
};

/**
 * Fonction qui gère les onglets et les buttons
 */
var setTab = function() {
	var nbStep = $('.inscription__step--item').length;

	// Menu
	$("li[data-tab]").removeClass('current');
	$("li[data-tab='"+inscriptionStep+"']").addClass('current');

	// Tab
	$("div[data-tab]").addClass('hide');
	$("div[data-tab='"+inscriptionStep+"']").removeClass('hide');
	
	// Btn
	$("#btn-prev-step, #btn-next-step, #btn-submit").addClass('hide');
	if(inscriptionStep > 1) $("#btn-prev-step").removeClass('hide');
	if(inscriptionStep < nbStep) $("#btn-next-step").removeClass('hide');
	if(inscriptionStep == nbStep) $("#btn-submit").removeClass('hide');

	// Type
	switch(inscriptionStep) {
		case 1:
			break;
		case 2:
			var msg    = "";
			var naissance = "";
			var fields = {
				"nom": "Nom",
				"prenom": "Prénom",
				"naissance": "Date de naissance",
				"telephone": "Téléphone"
			};

			for(var field in fields) {
				var val = $("input[name='~"+field+"']").val();
				if(val == '') msg += "\n  - "+fields[field];
				if(field == 'naissance' && val != '') {
					var m = val.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
					if(!m) naissance = "Format de le date de naissance erroné";
				}
			}

			if(msg) {
				alert("Les champs suivants sont obligatoires : "+msg);
				setTab(inscriptionStep--);
				return false;
			} else if(naissance) {
				alert(naissance);
				setTab(inscriptionStep--);
				return false;
			}
			break;
		case 3:
			$type = $("input[name='type']:checked");
			if($type.length == 0) {
				setTab(inscriptionStep--);
			}
			else {
				$(".formation[data-type]").addClass("hide");
				$(".formation[data-type='"+$type.val()+"']").removeClass("hide");
			}
			break;
		case 4:
			$type       = $("input[name='type']:checked");

			var champs = $type.val();
			if(champs == 'instrument') champs+='[0]';
			if(champs == 'ensemble') champs+='[]';
			if($("input[name='"+champs+"']:checked").length == 0)
				setTab(inscriptionStep--);

			break;
	}
};





$(document).ready(function() {

/*
####  ##    ##    ######     ######    ########   ####  ########   ########   ####   #######   ##    ##   
 ##   ###   ##   ##    ##   ##    ##   ##     ##   ##   ##     ##     ##       ##   ##     ##  ###   ##   
 ##   ####  ##   ##         ##         ##     ##   ##   ##     ##     ##       ##   ##     ##  ####  ##   
 ##   ## ## ##    ######    ##         ########    ##   ########      ##       ##   ##     ##  ## ## ##   
 ##   ##  ####         ##   ##         ##   ##     ##   ##            ##       ##   ##     ##  ##  ####   
 ##   ##   ###   ##    ##   ##    ##   ##    ##    ##   ##            ##       ##   ##     ##  ##   ###   
####  ##    ##    ######     ######    ##     ##  ####  ##            ##      ####   #######   ##    ##   
*/

	function updateContributionDisplay() {
		$(".form-json").validationEngine('hideAll');
		$("[data-contribution-display]").hide();
		$("[data-don-display]").hide();
		// $("input[name='~don']").prop("checked", false);
		// $("#don_libre_input").hide().val("");

		$("input[name='~contribution[]']:checked").each(function () {
			const choix = $(this).val();
			$("[data-contribution-display*='" + choix + "']").show();
		});
	}

	function updateDonDisplay() {
		$(".form-json").validationEngine('hideAll');
		const selected = $("input[name='~don']:checked").val();
		if (selected === "free") {
			$("#don_libre_input").show();
		} else {
			$("#don_libre_input").hide().val("");
		}
	}
	
	// var inscriptionStep = 1;
	// var inscriptionType = 0;

	// INSCRIPTION
	$(".form-json").validationEngine();
	$(".form-json").submit(function(){

		studentRequired = false;
		pictureRequired = false;
		ribRequired = false;
		sepaRequired = false;
		impotRequired = false;

		if($('.inscription__eleve--list').length) {
			if($("input[name='eleve[]']:checked'").length == 0) {
				studentRequired = true;
			} else {
				$("input[name='eleve[]']:checked'").each(function() {
					$eleve = $(this).closest('.inscription__eleve--box');
					if($eleve.find('.upload-instructions').length > 0)
						pictureRequired = true;
				});	
			}

			if(studentRequired) alert("Merci d'inscrire au moins un élève");
			if(pictureRequired) alert("Merci d'uploader une photo d'identité pour les élèves mineurs");	
		}

		if($("input[name='~paiement']:checked").val() == 'PRL') {

			if ($("#plupload-rib:contains('.')").length == 0) {
				ribRequired = true;
				alert("Merci d'uploader votre RIB");
			}

			if ($("#plupload-sepa:contains('.')").length == 0) {
				sepaRequired = true;
				alert("Merci d'uploader votre mandat de prélèvement complété et signé");
			}

		}


		if($("input[name='~fiscal']:checked").val() == 1) {

			if ($("#plupload-impot:contains('.')").length == 0) {
				impotRequired = true;
				alert("Merci d'uploader votre dernier avis d'imposition");
			}

		}

		

		if($(this).validationEngine('validate') && !pictureRequired && !studentRequired && !ribRequired && !sepaRequired && !impotRequired){

			var url  = $(this).attr("action");
			var data = $(this).serialize() + '&act=envoi';

			$.ajax({
				type    : "POST",
				data    : data,
				url     : url,
				success : function(retour) {
					try {
						var data = JSON.parse(retour);
						jsonHandler(data);
					} catch(ex) {
						console.log("Erreur inopinée");
					}
				}
			});
		}
		return false;
	});


	// Choix paiement
	$("input[name='~paiement']").change(function() {
		$(".form-json").validationEngine('hideAll');
		var paiement = $(this).val();
		$("[data-paiement-display]").hide();
		$("[data-paiement-display*='"+paiement+"']").show();

		$("[name='~prelevement']").removeAttr("checked");
	});

	// Choix fiscal
	$("input[name='~fiscal']").change(function() {
		$(".form-json").validationEngine('hideAll');
		var choix = $(this).val();
		$("[data-fiscal-display]").hide();
		$("[data-fiscal-display*='"+choix+"']").show();
	});

	// Initial binding
	$("input[name='~contribution[]']").change(updateContributionDisplay);
	$("input[name='~don']").change(updateDonDisplay);

	// Initial state (au cas où des cases seraient déjà cochées à l'ouverture)
	updateContributionDisplay();
	updateDonDisplay();

	$('.abort-event').click(function(e) {
		e.stopPropagation();
	});


	$('.inscription__eleve--box').magnificPopup({
		type:'ajax',
		modal: true,
		callbacks: {
			ajaxContentAdded: function() {
				inscriptionStep = 1;

				// Titre popup
				$("#formInscriptionEleve input[name='~nom'], #formInscriptionEleve input[name='~prenom']").keyup(function() {
					$nom    = $("#formInscriptionEleve input[name='~nom']");
					$prenom = $("#formInscriptionEleve input[name='~prenom']");
					$('.inscription__eleve--name').html($nom.val()+' '+$prenom.val());
				});

				// Etape suivante
				$("#btn-next-step").click(function() {
					var birthY = parseInt($("input[name='~naissance'").val().substring(6,10));
					var annee  = parseInt($("input[name='annee'").val());
					$('.inscription__accompagnateurs').hide();

					if(!isNaN(birthY)) {
						if((annee - birthY) < 18)
							$('.inscription__accompagnateurs').show();
					}

					setTab(inscriptionStep++);
				});

				// Etape precedente
				$("#btn-prev-step").click(function() {
					setTab(inscriptionStep--);
				});

				// Ajout d'un instrument
				$("#instrument-add").click(function(e) {
					e.preventDefault();
					$instrument = $('.instrument-item').clone().insertBefore($(this).parent()).removeClass('hide').removeClass('instrument-item');
					index = $instrument.index()-1;
					$instrument.find("input[type='radio']").attr('name', 'instrument['+index+']');
					$instrument.find("input[type='text']")
						.attr('placeholder', 'Instrument n°'+parseInt(index+1))
						.attr('name', 'instrument-nom['+index+']');
				});

				$("#formInscriptionEleve").submit(function() {
					var url  = $(this).attr("action");
					var data = $(this).serialize() + '&act=envoi';
					
					$.ajax({
						type    : "POST",
						data    : data,
						url     : url,
						success : function(retour) {
							try {
								var data = JSON.parse(retour);
								jsonHandler(data);
							} catch(ex) {
								console.log("Erreur inopinée");
							}
						}
					});
					return false;
				});

				$(".radio-btn--type").click(function() {
					$(".radio-btn--type").parent().removeClass('checked');
					$(this).parent().addClass('checked');
				});

				// Accompagnateurs
				$(".inscription__eleve--add-accompagnateur").click(function(e) {
					e.preventDefault();
					$row = $(this).closest('table').find('tbody tr:last');
					// console.log($row.html());
					// $row.after($row.find('input').val('').end());
					// console.log($row);
					$row.after($row.clone().find('input').val('').end().show());
					// .find('input').val('').attr('name','ee').end());
				});
			}
		}
	}).click(function(){
		// if( $(this).data('lot') ){
		// 	$('#quickmeet input[name="~lot"]').val( $(this).data('lot') );
		// 	$('#quickmeet .meet-lot-number').html( $(this).data('num') );
		// }
	});

	/*
	########   ##         ##     ##  ########   ##          #######      ###     ########   
	##     ##  ##         ##     ##  ##     ##  ##         ##     ##    ## ##    ##     ##  
	##     ##  ##         ##     ##  ##     ##  ##         ##     ##   ##   ##   ##     ##  
	########   ##         ##     ##  ########   ##         ##     ##  ##     ##  ##     ##  
	##         ##         ##     ##  ##         ##         ##     ##  #########  ##     ##  
	##         ##         ##     ##  ##         ##         ##     ##  ##     ##  ##     ##  
	##         ########    #######   ##         ########    #######   ##     ##  ########   
	*/

	var showProgressBar = function(up) {};
	var hideProgressBar = function(up) {};
	var uploadHandler = function(up, response) {
		$("#"+up.settings.drop_element).html(response);
	};


	
	if($(".upload-zone").length > 0) {

		var upldrs = [];

		$(".upload-zone").each(function() {
			$(this).bind('click', function(e) {
				e.stopPropagation();
		    });

			var drop_element = $(this).attr("id");
			var browse_button = $(this).attr("id");
			var data = {
				title: $(this).data('title'),
				extensions: $(this).data('extensions'),
				type: $(this).data('type'),
				id: $(this).data('id'),
				entity: $(this).data('entity'),
				field: $(this).data('field'),
			};

	        upld = new plupload.Uploader({
	            button_browse_hover : true,
				autostart: true,
				multi_selection: false,

		        runtimes : "html5",
			    url : "plupload/",
			    // max_file_size : '10mb',
				chunk_size : '1mb',

				// dragdrop: true,
				drop_element : drop_element,
				browse_button : browse_button,
				filters: {
					max_file_size : '10mb',
					mime_types: [
						{title : data.title, extensions : data.extensions}
					]
		        },
		        multipart_params : {
	            	"type" : data.type,
	                "id" : data.id,
	                "entity" : data.entity,
	                "field" : data.field
		        },
		        init: {
					FilesAdded: function(up, files){up.start(); showProgressBar(up);},
					UploadProgress: function(up, file){ $(".upld-progress").css("width", file.percent + "%"); },
					UploadComplete: function(up, file) { hideProgressBar(up);      },
					FileUploaded: function(up, file, resp) { uploadHandler(up, resp.response); },
				}
		    });
		    upld.init();
		    upldrs.push(upld);
	    });

	}

});
